import { Injectable } from '@angular/core';
import { AuthenticationService } from '@services/auth/authentication.service';

/**
 * Checks if a user is admin.
 */
@Injectable()
export class AdminGuard {
  constructor(private auth: AuthenticationService) {}

  public canActivate(): boolean {
    return this.auth.isAdmin;
  }
}
